

<template>
  <div>
    <label>{{label}}</label>
    <v-select v-model="selected" :multiple="multi" :options="options" @input="input" />
  </div>
</template>
<script>
export default {
  name: 'SelectList',
  props: ['multi', 'options', 'name', 'label', 'value'],
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    input(e) {
      this.$emit('input', e)
    },
  },
  mounted() {
    this.selected = this.value
  },
}
</script>